// extracted by mini-css-extract-plugin
module.exports = {"pintxo-field-container":"Field_pintxo-field-container__IMrLh","pintxo-field-container__footer":"Field_pintxo-field-container__footer__6Hfj2"};